import styled from "styled-components";

export const ModaBody = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  .branch-list {
    padding: 1rem 1rem 1rem 0;
    flex-basis: 40%;
    overflow-y: scroll;
  }
  .organization-list {
    flex-basis: 60%;
    .ant-spin-nested-loading {
      height: 100%;
    }
    .org-item {
      padding: 0.5rem 1rem;
      cursor: pointer;
      &.selected {
        background-color: #71a5e4;
        color: #fff !important;
        color: #666;
      }
    }
  }
`;

export const SearchInput = styled.div`
  display: inline-flex;
  .ant-select {
    width: 250px;
    margin-right: 10px;
  }
  .branch-icon {
    display: flex;
    align-items: center;
    background: #174a83;
    padding: 0 10px;
    border: 0.5px solid #f7f9fa;
    border-radius: 3px;
    cursor: pointer;
  }
`;
